import state from "../store/index";

const LeakTypes = [
  {
    key: 0,
    name: "main150",
    iconKey: "",
    displayName: state.getters["page/strings"].leakMain6
  },
  {
    key: 1,
    name: "main250",
    iconKey: "",
    displayName: state.getters["page/strings"].leakMain250
  },
  {
    key: 2,
    name: "main250+",
    iconKey: "",
    displayName: state.getters["page/strings"].leakMain251
  },
  { key: 3, name: "sluice", iconKey: "", displayName: state.getters["page/strings"].leakSluiceValve },
  { key: 4, name: "airValve", iconKey: "", displayName: state.getters["page/strings"].leakAirValve },
  { key: 5, name: "fireHydrant", iconKey: "", displayName: state.getters["page/strings"].leakFireHydrant },
  { key: 6, name: "washout", iconKey: "", displayName: state.getters["page/strings"].leakWashout },
  { key: 7, name: "meter", iconKey: "", displayName: state.getters["page/strings"].leakMeter },
  { key: 8, name: "stopTap", iconKey: "", displayName: state.getters["page/strings"].leakStopTap },
  {
    key: 9,
    name: "commPipe",
    iconKey: "",
    displayName: state.getters["page/strings"].leakCommPipe
  },
  {
    key: 10,
    name: "servicePipe",
    iconKey: "",
    displayName: state.getters["page/strings"].leakServicePipe
  },
  { key: 11, name: "btbb", iconKey: "", displayName: state.getters["page/strings"].leakBtbb },
  { key: 12, name: "ferrule", iconKey: "", displayName: state.getters["page/strings"].leakFerrule },
  { key: 13, name: "waste", iconKey: "", displayName: state.getters["page/strings"].leakWasteNotice },
  { key: 14, name: "other", iconKey: "", displayName: state.getters["page/strings"].leakOther },
  { key: 15, name: "enabling", iconKey: "", displayName: state.getters["page/strings"].leakEnabling },
  {
    key: 16,
    name: "fireFixed",
    iconKey: "",
    displayName: state.getters["page/strings"].leakFireFixed
  },
  {
    key: 17,
    name: "washoutFixed",
    iconKey: "",
    displayName: state.getters["page/strings"].leakWashoutFixed
  },
  {
    key: 18,
    name: "uConsumptionSm",
    iconKey: "",
    displayName: state.getters["page/strings"].leakUnrecordedConsumptionS
  },
  {
    key: 19,
    name: "uConsumptionMd",
    iconKey: "",
    displayName: state.getters["page/strings"].leakUnrecordedConsumptionM
  },
  {
    key: 20,
    name: "uConsumptionLg",
    iconKey: "",
    displayName: state.getters["page/strings"].leakUnrecordedConsumptionL
  },
  {
    key: 21,
    name: "wasteOverflow",
    iconKey: "",
    displayName: state.getters["page/strings"].leakWasteOverflow
  },
  {
    key: 22,
    name: "sluiceFixed",
    iconKey: "",
    displayName: state.getters["page/strings"].leakSluiceFixed
  },
  {
    key: 23,
    name: "stopTapFixed",
    iconKey: "",
    displayName: state.getters["page/strings"].leakStopTapFixed
  },
  {
    key: 24,
    name: "airFixed",
    iconKey: "",
    displayName: state.getters["page/strings"].leakAirValveFixed
  },
  {
    key: 25,
    name: "meterFixed",
    iconKey: "",
    displayName: state.getters["page/strings"].leakMeterFixed
  },
  { key: 26, name: "btbbLow", iconKey: "", displayName: state.getters["page/strings"].leakBtbbLow }
];

const NoLeakReasons = [
  {
    key: 0,
    name: "airConditioningUnit",
    displayName: state.getters["page/strings"].noLeakAirCondition
  },
  {
    key: 1,
    name: "electricalNoise",
    displayName: state.getters["page/strings"].noLeakElectricalNoise
  },
  {
    key: 2,
    name: "industrialuser",
    displayName: state.getters["page/strings"].noLeakIndustrialUser
  },
  {
    key: 3,
    name: "prv",
    displayName: state.getters["page/strings"].prv
  },
  {
    key: 4,
    name: "other",
    displayName: state.getters["page/strings"].other
  },
  {
    key: 5,
    name: "usage",
    displayName: state.getters["page/strings"].noLeakUsage
  },
  {
    key: 6,
    name: "mechanicalNoise",
    displayName: state.getters["page/strings"].noLeakMechanicalNoise
  },
  {
    key: 7,
    name: "rattlingValve",
    displayName: state.getters["page/strings"].noLeakRattlingValve
  },
  {
    key: 8,
    name: "wasteWater",
    displayName: state.getters["page/strings"].noLeakWasteWaterPipe
  },
  {
    key: 9,
    name: "stormDrain",
    displayName: state.getters["page/strings"].noLeakStormDrain
  }

];

// Electrical noise
// Industrial User
// PRV
// Air Conditioning Unit 
// Other


export { LeakTypes, NoLeakReasons };
